<template>
  <div class="step-info">
    <div class="step-info__row">
      <div class="step-info__field step-info__field--full">
        <label>Nome <span class="required">*</span></label>
        <input
          type="text"
          class="form-control"
          v-model="form.nome"
          placeholder="Ex: Linha Premium VERSO"
          maxlength="120"
        />
      </div>
    </div>

    <div class="step-info__row">
      <div class="step-info__field step-info__field--full">
        <label>Descrição</label>
        <textarea
          class="form-control"
          v-model="form.descricao"
          placeholder="Descrição opcional do grupo..."
          rows="3"
          maxlength="500"
        ></textarea>
      </div>
    </div>

    <div class="step-info__row step-info__row--cols">
      <div class="step-info__field">
        <label>Ativo <span class="required">*</span></label>
        <select class="form-control" v-model.number="form.ativo">
          <option :value="1">Sim</option>
          <option :value="0">Não</option>
        </select>
      </div>
      <div class="step-info__field" />
    </div>
  </div>
</template>

<script>
export default {
  name: "StepInformacoes",
  props: { form: { type: Object, required: true } },
};
</script>

<style scoped>
.step-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.step-info__row {
  display: flex;
  gap: 16px;
}

.step-info__row--cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.step-info__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.step-info__field--full {
  flex: 1;
}

.step-info__field label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.step-info__field .form-control {
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #dddce9;
  padding: 8px 10px;
}

.step-info__field .form-control:focus {
  border-color: #3a3e81;
  box-shadow: 0 0 0 2px rgba(58, 62, 129, 0.1);
}

.required {
  color: #e74c3c;
}
</style>
